define('../app/fukit/configuration/model.configuration',['require','exports','module','datakit/datakit'],function(require, exports, module) {
  var DataKit = require('datakit/datakit');

  var ModelConfiguration = {
    radioEvents: {
      'app configure': 'onAppConfigure',
    },

    onAppConfigure: function() {
      // this configures the content type that models should serialize to
      DataKit.HalModel.contentType = 'application/hal+json';
    },
  };

  module.exports = ModelConfiguration;
});

